export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const WEBSITE_LINK_REGEX = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}([\/?#].*)?$/;
export const COMPANY_NAME_REGEX = /^[A-Za-z0-9\s&().,'-]*$/;
export const STRONG_PASSWORD = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_+\-=])[A-Za-z\d@$!%*?&#^()_+\-=]{6,}$/;
export const ALPHABET_NAME_REGEX = /^[A-Za-z\s'-]+$/;
export const UAE_MOBILE_REGEX = /^0?5[024568]\d{7}$/;
export const IN_MOBILE_REGEX = /^0?[6-9]\d{9}$/;

// Emirate Id 
export const EMIRATI_ID_REGEX = /^784-\d{4}-\d{7}-\d{1}$/;
